const getTotalAmount = (rows, balance, formatted) => {
    let amount = 0;
    let amount_tax_1 = 0;
    let amount_tax_2 = 0;
    let amount_tax_3 = 0;
    let amount_tax_4 = 0;
    rows.forEach((row) => {
        row.data.fields.entries.value.forEach((entry) => {
            if (entry.fields.created_at.value !== null) {
                switch (entry.fields.type.value) {
                    case 'CHARGE':
                    case 'POSITIVE_ADJUSTMENT':
                    case 'REFUND':
                    case 'REVERSAL':
                    case 'UNAPPLY_CREDIT':
                        amount += entry.fields.amount.value;
                        amount_tax_1 += entry.fields.amount_tax_1.value;
                        amount_tax_2 += entry.fields.amount_tax_2.value;
                        amount_tax_3 += entry.fields.amount_tax_3.value;
                        amount_tax_4 += entry.fields.amount_tax_4.value;
                        break;
                    case 'PAYMENT':
                    case 'ADJUSTMENT':
                    case 'LANDLORD_COLLECTED':
                    case 'WRITE_OFF':
                        amount -= entry.fields.amount.value;
                        amount_tax_1 -= entry.fields.amount_tax_1.value;
                        amount_tax_2 -= entry.fields.amount_tax_2.value;
                        amount_tax_3 -= entry.fields.amount_tax_3.value;
                        amount_tax_4 -= entry.fields.amount_tax_4.value;
                        break;
                    default:
                }
            }
        });
    });

    return formatted ? {
        amount,
        amount_tax_1,
        amount_tax_2,
        amount_tax_3,
        amount_tax_4,
    } : {
        amount: {
            value: amount
        },
        amount_tax_1: {
            value: amount_tax_1
        },
        amount_tax_2: {
            value: amount_tax_2
        },
        amount_tax_3: {
            value: amount_tax_3
        },
        amount_tax_4: {
            value: amount_tax_4
        },
        gross_amount: {
            value: balance
        },
    };
};

export default getTotalAmount